import React, { FC } from "react";
import { InputNumber, InputSelect, InputText } from "../../../../components/input";
import { IInputArrayFormProps, IInputArrayDataStructureItem } from "../../../../components/input/arrayData";
import { CreateNotification } from "../../../../components/notifier";
import { Button } from "../../../../modules/button";
import { InputWraper, useForm } from "../../../../modules/form";
import { ObjectUtils } from "../../../../modules/utils";
import { InputSelectTag } from "../../../../components/input/select-tag";

const eSystemOptions = [
  {
    label: "CM",
    value: "CM",
  },
  {
    label: "FM",
    value: "FM",
  },
  {
    label: "CM và FM",
    value: "CM và FM",
  },
];

const eUserGroupsOptions = [
  {
    label: "Quản lý",
    value: "Quản lý",
  },
  {
    label: "SUP",
    value: "SUP",
  },
  {
    label: "Nhân viên",
    value: "Nhân viên",
  },
  {
    label: "Viewer",
    value: "Viewer",
  },
];

export const CodeEprProcessContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: "Users",
    label: "Người sử dụng",
    isVisibleOnList: true,
  },
  {
    name: "EmployeeCode",
    label: "Mã nhân viên",
    isVisibleOnList: true,
  },
  {
    name: "WorkingDepartment",
    label: "Bộ phận công tác",
    isVisibleOnList: true,
  },
  {
    name: "Title",
    label: "Chức danh",
    isVisibleOnList: true,
  },
  {
    name: "System",
    label: "Hệ thống",
    isVisibleOnList: true,
  },
  {
    name: "FunctionCode",
    label: "Nhóm User",
    isVisibleOnList: true,
  },
  {
    name: "CaseHasBeenGranted",
    label: "User ID đã được cấp (nếu có)",
    isVisibleOnList: true,
  },
  {
    name: "Request",
    label: "Đề Nghị",
    isVisibleOnList: true,
  },
  {
    name: "DetailedDescriptionOfTheRequest",
    label: "Chi tiết đề nghị",
    isVisibleOnList: true,
  },
  {
    name: "CodePcc",
    label: "Sân bay trực thuộc (SGN/HAN/DAD/ALL)",
    isVisibleOnList: true,
  },
  {
    name: "Email",
    label: "Email",
    isVisibleOnList: true,
  },
  {
    name: "PhoneNumber",
    label: "Số điện thoại",
    isVisibleOnList: true,
  },
  {
    name: "IdUser",
    label: "CMND/CCCD",
    isVisibleOnList: true,
  },
];

export const CodeEprProcessContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item) => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue,
      };
    }),
    onSubmit: (values) => {
      const clonedValues = { ...values };
      const { FunctionCode } = values;
      clonedValues.FunctionCode = FunctionCode?.value || FunctionCode;

      if (
        !clonedValues.Users ||
        !clonedValues.EmployeeCode ||
        !clonedValues.WorkingDepartment ||
        !clonedValues.Title ||
        !clonedValues.Email ||
        !clonedValues.PhoneNumber ||
        !clonedValues.IdUser ||
        !clonedValues.FunctionCode ||
        !clonedValues.System
      )
        CreateNotification({
          title: "Thông báo",
          body: "Vui lòng nhập đầy đủ thông tin yêu cầu!",
          icon: "/icons/warning.png",
        });
      else props.onSubmit(clonedValues);
    },
  });

  return (
    <div className="Form__add-new py-3">
      <h6>
        ( <span className="star_content">*</span> ): Trường thông tin bắt buộc phải nhập{" "}
      </h6>

      <InputWraper inputProps={getInputProps("Users")} renderInput={(s) => <InputText {...s} error />} isRequired />

      <InputWraper inputProps={getInputProps("EmployeeCode")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("WorkingDepartment")}
        renderInput={(s) => <InputText {...s} />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("Title")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper
        inputProps={getInputProps("System")}
        renderInput={(s) => <InputSelectTag {...s} options={eSystemOptions} placeholder="* Vui lòng chọn hệ thống" />}
        isRequired
      />

      <InputWraper
        inputProps={getInputProps("FunctionCode")}
        renderInput={(s) => <InputSelect {...s} options={eUserGroupsOptions} placeholder="* Vui lòng chọn nhóm user" />}
        isRequired
      />

      <InputWraper inputProps={getInputProps("CodePcc")} renderInput={(s) => <InputText {...s} />} isRequired />

      <InputWraper inputProps={getInputProps("Email")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("PhoneNumber")} renderInput={(s) => <InputNumber {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("IdUser")} renderInput={(s) => <InputNumber {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("CaseHasBeenGranted")} renderInput={(s) => <InputText {...s} />} />
      <InputWraper inputProps={getInputProps("Request")} renderInput={(s) => <InputText {...s} />} />
      <InputWraper
        inputProps={getInputProps("DetailedDescriptionOfTheRequest")}
        renderInput={(s) => <InputText {...s} />}
      />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
};
